// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"500a5eff","195":"997c11f3","204":"0d400b0a","281":"8d875d3c","324":"ff77be7a","599":"fe241392","728":"0239bc40","876":"64c5f76f","943":"ab5d7276","994":"02a1b4a3"}[chunkId] + ".chunk.js";
};